<ng-template #content let-modal>
  <div class="matching-modal">
    <div class="matching-modal-header">
      <div class="matching-modal-heading">
        <span class="matching-modal-icon">
          <i [class]="getStepIcon()"></i>
        </span>
        <div>
          <div class="matching-modal-title">{{ getTitle() }}</div>
          <div class="matching-modal-subtitle">{{ getSubtitle() }}</div>
        </div>
      </div>
      <button
        class="btn matching-modal-close"
        (click)="modal.dismiss('CANCEL')"
        [title]="app.text.thread.close"
        >
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="matching-modal-body">
      @if (type === 'discard') {
        <div class="matching-modal-message">
          @if (step === 'currentMatch') {
            <span>
              {{ app.text.matchingManufacturerModal.currentMatch }}
            </span>
          }
          @if (step === 'keepCurrentMatch') {
            <span>
              {{ app.text.matchingManufacturerModal.keepCurrentMatch }}
            </span>
          }
          @if (step === 'discardCurrentMatch') {
            <span>
              {{ app.text.matchingManufacturerModal.discardCurrentMatch }}
            </span>
          }
        </div>
      }
      @if (type === 'save') {
        <div class="matching-modal-message">
          @if (step === 'selectItem') {
            <span>
              {{ app.text.matchingManufacturerModal.selectItem }}
            </span>
          }
          @if (step === 'loadData') {
            <span>
              {{ app.text.matchingManufacturerModal.loadedData }}
            </span>
          }
        </div>
      }
    </div>

    <div class="matching-modal-footer">
      <button
        class="btn matching-modal-action matching-modal-action-secondary"
        (click)="goToNext(step, 'dismiss')"
        >
        {{ getButtonText("dismiss") }}
      </button>
      <button
        class="btn matching-modal-action matching-modal-action-primary"
        (click)="goToNext(step, 'save')"
        >
        {{ getButtonText("save") }}
      </button>
    </div>
  </div>
</ng-template>
